const IconStyles = `
  .nts-icon--l {
    height: 32px;
    width: 32px;
  }

  .nts-icon--overlay {
    background-color: var(--nts-white);
    box-sizing: content-box;
    box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.05);
    padding: 8px 16px;
  }

  .nts-icon--scroll-button {
    height: 24px;
    width: 24px;
  }

  .nts-icon--inverted {
    fill: var(--nts-white);
  }

  @media(min-width: 1025px) {
    .nts-icon--l {
      height: 64px;
      width: 64px;
    }

    .nts-icon--overlay:not(.nts-icon--overlay--list) {
      background-color: transparent;
      box-shadow: none;
      fill: var(--nts-white);
      filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.25));
      transition: opacity 0.1s linear;
    }
  }
`

export default IconStyles
